// src/services/ordersService.js
import http from "../api/http";

/** Normalise la liste /orders/:codtiers */
function mapOrderListItem(row) {
  const id = row.id ?? row.Id ?? row.ID ?? row.Guid ?? row.guid; // <- GUID
  const nf = row.nf ?? row.Nf;
  const dat = row.datuser ?? row.DatUser;
  const total = row.mntdebit ?? row.MntDebit;
  const dbName = row.dbName;

  return {
    id, // <- IMPORTANT
    nf,
    dbName,
    date: dat ? new Date(dat) : null,
    total: Number(total ?? 0),
    adresseA: row.AdresseA ?? row.adresseA ?? null,
  };
}


/** Entête /orders/:nf/header */
function mapOrderHeader(db) {
  if (!db) return null;
  return {
    nf      : db.Nf ?? db.nf,
    client  : db.LibTiers ?? db.libTiers,
    adresse : db.Adresse ?? db.adresse,
    remarq  : db.Remarq ?? db.remarq,
    totHT   : Number((db.TotHT ?? db.totHT) ?? 0),
    totTVA  : Number((db.TotTva ?? db.totTva) ?? 0),
    totRem  : Number((db.TotRem ?? db.totRem) ?? 0),
    totTTC  : Number((db.TotTTC ?? db.totTTC) ?? 0),
    datUser : (db.DatUser ?? db.datUser) ? new Date(db.DatUser ?? db.datUser) : null,
    repres  : db.DesRepres ?? db.desRepres,
    villeA  : db.VilleA ?? db.villeA,
    raw     : db,
  };
}

/** Lignes /orders/:nf/lines */
function mapOrderLine(row) {
  return {
    codArt : row.Codart ?? row.codart ?? row.CodArt ?? row.codArt,
    libArt : row.libart ?? row.LibArt ?? row.libArt,
    qt     :Number(row.qt ?? row.Qt ?? 0),    
    liv    : Number(row.Liv ?? row.liv ?? 0),
    puht   : Number(row.puht ?? row.PUHT ?? 0),
    puttc  : Number(row.puttc ?? row.PUTTC ?? 0),
    mntRem : Number(row.MntRem ?? row.mntRem ?? 0),
    mntTVA : Number(row.MntTVA ?? row.mntTVA ?? 0),
  };
}

export const ordersService = {
  listByClient: async (codtiers) => {
    const { data } = await http.get(`/api/orders/${encodeURIComponent(codtiers)}`);
    const rows = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    return rows.map(mapOrderListItem);
  },

   getHeader: async (dbName, guid) => {
    const { data } = await http.get(`/api/orders/${encodeURIComponent(dbName)}/${encodeURIComponent(guid)}/header`);
    return mapOrderHeader(data?.item ?? data);
  },

  getLines: async (dbName, guid) => {
    const { data } = await http.get(`/api/orders/${encodeURIComponent(dbName)}/${encodeURIComponent(guid)}/lines`);
    const rows = Array.isArray(data?.items) ? data.items : [];
    return rows.map(mapOrderLine);
  },
};
